import React, { useState, useEffect, useRef } from 'react'
import { graphColor } from "../../../constants/Colors";
import { Bar, Line } from "react-chartjs-2";
import { Chart, registerables, Plugin } from 'chart.js'
import BackButton from '../../../clientComponents/BackButton/BackButton';
import { CustomTab, Select } from '../../../atomicComponents';
import { path_Operation } from '../../../constants/constVariables';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthorizationContext } from '../../../providers/AuthorizationHandler/AuthorizationHandler';
import { getPlantValue, postUsageAnalyticsCall } from '../../../constants/Utils';
import Loader from '../../Loader';
import styles from './DashboardAnalytics.module.css'
import clsx from 'clsx';
import { dashboardAnalyticsAreaParkingCapacityApi, dashboardAnalyticsOverspeedCountApi, dashboardAnalyticsParkedVINApi, dashboardAnalyticsTripDailyApi, dashboardAnalyticsTripWeeklyApi, listPlantsApi } from '../../../utils/apiServices';
Chart.register(...registerables)

export default function DashboardAnalytics() {

    const filterPlantName = getPlantValue();
    const [bulkSearchButton, setBulkSearchButton] = useState(false);
    const [overspeeding, setOverspeeding] = useState([]);
    const [areaCapacity, setAreaCapacity] = useState([]);
    const [areaCapacityAxis, setAreaCapacityAxis] = useState({});
    const [overspeedingLabel, setOverspeedingLabel] = useState([]);
    const [currentFilter, setcurrentFilter] = useState(filterPlantName);
    const [loader, setLoader] = useState(false);
    const [isbulkDownloaded, setIsBulkDownloaded] = useState(false);
    const [pageLeaveTime, setPageLeaveTime] = useState();
    const [plantFilter, setPlantFilter] = useState({});
    const [tripDaily, setTripDaily] = useState([]);
    const [tripWeekly, setTripWeekly] = useState([]);
    const [parked, setParked] = useState([]);
    const [graphWidth, setGraphWidth] = useState(1500)
    // const [legend, setLegend] = useState();
    // const [ref,setRef] = useState();
    const location = useLocation();
    const { user } = useAuthorizationContext();
    const [foundMode, setFoundMode] = useState(true);
    const [areaCapacityHeading, setAreaCapacityHeading] = useState([]);
    const [areaGraphRefresh, setAreaGraphRefresh] = useState(0);
    const [options_mixed_graph, setOptions_mixed_graph] = useState()
    const MixedRef = useRef()
    const OverspeedingRef = useRef()
    const ParkedVehicleRef = useRef()
    const DailyTripRef = useRef()
    const WeeklyTripRef = useRef()


    const overspeedCount = async () => {
        // console.log("object", currentFilter.value);
        const response = await dashboardAnalyticsOverspeedCountApi(currentFilter.value);
        const responseParkedVin = await dashboardAnalyticsParkedVINApi(currentFilter.value);
        const responseAreaCapacity = await dashboardAnalyticsAreaParkingCapacityApi(currentFilter.value);
        // console.log("response = ", response.data.data);
        // console.log("response 2 = ", responseParkedVin.data.data);
        // console.log("response 3 = ", responseAreaCapacity.data.data);
        setLoader(true);
        var heading = [];
        var data = [];
        response.data.data.map((val, index) => {
            heading.push(String(new Date(val.day).getDate()).padStart(2, 0) + '/' + String(new Date(val.day).getMonth() + 1).padStart(2, 0));
            data.push(val.overspeed_count)
        })
        // console.log("arr = ", heading, data);
        setOverspeeding({
            labels: heading,
            datasets: [
                {
                    data: data,
                    label: 'Overspeeding Count',
                    backgroundColor: graphColor.barGraph,
                    borderColor: graphColor.barGraph,
                    borderWidth: 1,
                    hoverBackgroundColor: graphColor.barGraphOnHover,
                    hoverBorderColor: graphColor.barBorderOnHover,
                    type: 'bar',
                    order: 1,
                }
            ]
        });

    }
    const areawiseCapacity = async () => {
        const response = await dashboardAnalyticsAreaParkingCapacityApi(currentFilter.value);
        // setLoader(true);
        // console.log("areawiseCapacity", response)
        var heading = [];
        var parkingCapacity = [];
        var occupiedSpace = [];
        var freeSpace = [];
        response.data.data.map((val, index) => {
            return val.area_data.map((subvalue, subindex) => {
                heading.push(subvalue.name);
                parkingCapacity.push(subvalue.parking_capacity)
                occupiedSpace.push(subvalue.occupied_space)
                freeSpace.push(subvalue.free_space)
            })
        })
        // console.log('parkingCapacity = ', parkingCapacity.length)
        setAreaCapacityHeading([...heading])

        // heading.length>1?setGraphWidth(1500):setGraphWidth(400)
        setAreaCapacity({
            labels: heading,
            datasets: [
                {
                    data: parkingCapacity,
                    label: 'Parking Capacity',
                    borderWidth: 2,
                    borderColor: graphColor.lineGraph,
                    pointBackgroundColor: graphColor.lineGraph,
                    order: 1,
                    type: 'line'
                },
                {
                    data: occupiedSpace,
                    label: 'Occupied Space',
                    borderWidth: 1,
                    backgroundColor: graphColor.barGraph,
                    borderColor: graphColor.barGraph,
                    hoverBackgroundColor: graphColor.barGraphOnHover,
                    hoverBorderColor: graphColor.barBorderOnHover,
                    order: 1,
                    type: 'bar'
                },
                {
                    data: freeSpace,
                    label: 'Free Space',
                    borderWidth: 1,
                    backgroundColor: graphColor.barGraphLight,
                    borderColor: graphColor.barGraphLight,
                    hoverBackgroundColor: graphColor.barGraphOnHoverLight,
                    hoverBorderColor: graphColor.barBorderOnHoverLight,
                    order: 1,
                    type: 'bar'
                },

            ]
        })
        setAreaCapacityAxis({
            labels: [],
            datasets: [
                {
                    data: parkingCapacity,
                    label: 'Parking Capacity',
                },
                {
                    data: occupiedSpace,
                    label: 'Occupied Space',
                },
                {
                    data: freeSpace,
                    label: 'Free Space',
                },

            ]
        })
    }
    const getTripDaily = async () => {
        const response = await dashboardAnalyticsTripDailyApi(currentFilter.value);
        // setLoader(true);
        var heading = [];
        var data = [];
        // console.log("trips daily", response)
        response.data.data.map((val, index) => {
            heading.push(String(new Date(val.day).getDate()).padStart(2, 0) + '/' + String(new Date(val.day).getMonth() + 1).padStart(2, 0))
            data.push(val.no_trip)
        }
        )
        setTripDaily({
            labels: heading,
            datasets: [
                {
                    data: data,
                    label: 'Trip Daily',
                    backgroundColor: graphColor.barGraph,
                    borderColor: graphColor.barGraph,
                    borderWidth: 1,
                    hoverBackgroundColor: graphColor.barGraphOnHover,
                    hoverBorderColor: graphColor.barBorderOnHover,
                    type: 'bar',
                    order: 1,
                }
            ]
        });
    }
    const getTripWeekly = async () => {
        const response = await dashboardAnalyticsTripWeeklyApi(currentFilter.value);
        // setLoader(true);
        var heading = [];
        var data = [];
        // console.log("trips weekly", response)
        response.data.data.map((val, index) => {
            heading.push(String(new Date(val.week_start_date).getDate()).padStart(2, 0) + '/' + String(new Date(val.week_start_date).getMonth()+1).padStart(2, 0) + ' - ' + String(new Date(val.week_end_date).getDate()).padStart(2, 0) + '/' + String(new Date(val.week_end_date).getMonth()+1).padStart(2, 0))
            data.push(val.no_trip)
        }
        )
        setTripWeekly({
            labels: heading,
            datasets: [
                {
                    data: data,
                    label: 'Trip Daily',
                    backgroundColor: graphColor.barGraph,
                    borderColor: graphColor.barGraph,
                    borderWidth: 1,
                    hoverBackgroundColor: graphColor.barGraphOnHover,
                    hoverBorderColor: graphColor.barBorderOnHover,
                    barThickness: 20,
                    type: 'bar',
                    order: 1,
                }
            ]
        });
    }
    const getParkedVIN = async () => {
        const response = await dashboardAnalyticsParkedVINApi(currentFilter.value);
        // setLoader(true);
        var heading = [];
        var nonTCUData = [];
        var TCUData = [];
        // console.log("parked vins", response)
        response.data.data?.non_tcu_data?.map((val, index) => {
            heading.push(String(new Date(val.day).getDate()).padStart(2, 0) + '/' + String(new Date(val.day).getMonth() + 1).padStart(2, 0))
            nonTCUData.push(val.vin_count)
        })
        response.data.data?.tcu_data?.map((val, index) => {
            // var dateString = String(new Date(val.day).getDate()).padStart(2, 0) + '/' + String(new Date(val.day).getMonth()).padStart(2, 0);
            // if (!heading.includes(dateString)) {
            //     heading.unshift(String(new Date(val.day).getDate()).padStart(2, 0) + '/' + String(new Date(val.day).getMonth()).padStart(2, 0))
            // }
            TCUData.push(val.vin_count)
        })

        setParked({
            labels: heading,
            datasets: [
                {
                    data: TCUData,
                    label: 'TCU',
                    borderWidth: 2,
                    borderColor: graphColor.lineGraph,
                    pointBackgroundColor: graphColor.lineGraph,
                    order: 1,
                    type: 'line',
                },
                {
                    data: nonTCUData,
                    label: 'Non-TCU',
                    borderWidth: 2,
                    borderColor: graphColor.barGraph,
                    pointBackgroundColor: graphColor.barGraph,
                    order: 1,
                    type: 'line'
                }
            ]
        });
    }
    

    // const onRefChange = useCallback(node=>{
    //     setRef(node);
    //     if(node!== null){
    //         console.log("node",node.getChart)
    //         // setLegend(node.chartInstance.generateLegend())
    //     }
    // },[]);
    // const htmlLegendPlugin = {
    //     id: "htmlLegend",
    //     afterUpdate(chart) {
    //         const items = chart.options.plugins.legend.labels.generateLabels(chart);
    //         const ul = document.createElement("ul");
    //         items.forEach(item => {
    //             const li = document.createElement("li");
    //             const boxSpan = document.createElement("span");
    //             boxSpan.style.background = item.fillStyle;
    //             li.appendChild(boxSpan);
    //             li.appendChild(document.createTextNode(item.text));
    //             ul.appendChild(li);
    //         });
    //         const jsLegend = document.getElementById("js-legend");
    //         jsLegend.appendChild(ul);
    //     }
    // };
    const options_overspeeding = {
        responsive: true,
        barPercentage: 1,
        categoryPercentage: 0.3,
        borderRadius: 3,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Date',
                    font: {
                        family: 'Open Sans',
                        size: 12,
                        weight: 600,
                        color: graphColor.title
                    }
                },
                display: true,
                border: {
                    color: graphColor.border
                },
                grid: {
                    display: false
                },

            },
            y: {
                title: {
                    display: true,
                    text: 'Count',
                    font: {
                        family: 'Open Sans',
                        size: 12,
                        weight: 600,
                        color: graphColor.title
                    }
                },
                grid: {
                    color: graphColor.gridline,
                    tickColor: 'white'
                },
                ticks: {
                    display: true,
                    beginAtZero: false,
                    callback: function (value) { if (value % 1 === 0) { return value; } }
                },
                border: {
                    color: graphColor.border,
                    dash: [2, 2]
                },
                tickBorder: {
                    dash: [0, 0]
                },
                display: true,
            },
        }
    }
    const options_trips_daily = {
        responsive: true,
        barPercentage: 1,
        categoryPercentage: 0.3,
        borderRadius: 3,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Date',
                    font: {
                        family: 'Open Sans',
                        size: 12,
                        weight: 600,
                        color: graphColor.title
                    }
                },
                display: true,
                border: {
                    color: graphColor.border
                },
                grid: {
                    display: false
                },

            },
            y: {
                title: {
                    display: true,
                    text: 'Trips',
                    font: {
                        family: 'Open Sans',
                        size: 12,
                        weight: 600,
                        color: graphColor.title
                    }
                },
                grid: {
                    color: graphColor.gridline,
                    tickColor: graphColor.tick
                },
                ticks: {
                    display: true,
                    beginAtZero: false,
                    callback: function (value) { if (value % 1 === 0) { return value; } }
                },
                border: {
                    color: graphColor.border,
                    dash: [2, 2]
                },
                tickBorder: {
                    dash: [0, 0]
                },
                display: true,
            },
        }
    }
    const options_trip_weekly = {
        responsive: true,
        barPercentage: 1,
        categoryPercentage: 0.4,
        borderRadius: 3,
        indexAxis: 'y',
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Count',
                    font: {
                        family: 'Open Sans',
                        size: 12,
                        weight: 600,
                        color: graphColor.title
                    }
                },
                display: true,
                grid: {
                    color: graphColor.gridline,
                    tickColor: graphColor.tick
                },
                border: {
                    color: graphColor.border,
                    dash: [2, 2]
                },
                ticks: {
                    display: true,
                    beginAtZero: false,
                    callback: function (value) { if (value % 1 === 0) { return value; } }
                },
                tickBorder: {
                    dash: [0, 0]
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Weeks',
                    font: {
                        family: 'Open Sans',
                        size: 12,
                        weight: 600,
                        color: graphColor.title
                    }
                },
                grid: {
                    display: false
                },
                ticks: {
                    display: true,
                    beginAtZero: false,
                    // stepSize: 4    // need to change dynamically    
                    // count: 7 // adjusts according to scale value
                },
                border: {
                    color: graphColor.border
                },
                display: true,
            },
        }
    }
    const options_line_graph = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                labels: {
                    usePointStyle: true,
                    pointStyle: 'rect',
                    boxWidth: 7,
                    boxHeight: 7
                },
                position: 'top',
                // align: 'start',
            },
            // legendCallback:(chartInstance)=>{
            //     let labels = chartInstance.data.labels
            //     let colors = chartInstance.data.datasets[0].backgroundColor
            //     let borderWidth = chartInstance.data.datasets[0].borderWidth
            //     return (
            //         <ul className='chart-legend'>
            //             {labels && labels.map((label,index)=>(
            //                 <li >
            //                     <div className='legend-block' style={{backgroundColor: colors[index], borderWidth: `${borderWidth}px solid`}}>
            //                         {labels && <div className='legend-label'>{labels[index]}</div>}
            //                     </div>
            //                 </li>
            //             ))}
            //         </ul>
            //     )
            // },
            title: {
                display: false,
                // text: 'Custom Chart Title',
                // position: 'top',
                // align: 'start'
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Date',
                    font: {
                        family: 'Open Sans',
                        size: 12,
                        weight: 600,
                        color: graphColor.title
                    }
                },
                display: true,
                border: {
                    color: graphColor.border
                },
                grid: {
                    display: false
                },

            },
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Count',
                    font: {
                        family: 'Open Sans',
                        size: 12,
                        weight: 600,
                        color: graphColor.title
                    }
                },
                grid: {
                    color: graphColor.gridline,
                    tickColor: graphColor.tick
                },
                ticks: {
                    display: true,
                    beginAtZero: false,
                    callback: function (value) { if (value % 1 === 0) { return value; } }
                },
                border: {
                    color: graphColor.border,
                    dash: [2, 2]
                },
                tickBorder: {
                    dash: [0, 0]
                },
                display: true,
            },
        }
    }


    // const getOrCreateTooltip = (chart) => {
    //     let tooltipEl = chart.canvas.parentNode.querySelector('div');

    //     if (!tooltipEl) {
    //         tooltipEl = document.createElement('div');
    //         tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
    //         tooltipEl.style.borderRadius = '3px';
    //         tooltipEl.style.color = 'white';
    //         tooltipEl.style.opacity = 1;
    //         tooltipEl.style.pointerEvents = 'none';
    //         tooltipEl.style.position = 'absolute';
    //         tooltipEl.style.transform = 'translate(-50%, 0)';
    //         tooltipEl.style.transition = 'all .1s ease';

    //         const table = document.createElement('table');
    //         table.style.margin = '0px';

    //         tooltipEl.appendChild(table);
    //         chart.canvas.parentNode.appendChild(tooltipEl);
    //     }

    //     return tooltipEl;
    // };
    // const externalTooltipHandler = (context) => {
    //     // Tooltip Element
    //     const { chart, tooltip } = context;
    //     const tooltipEl = getOrCreateTooltip(chart);
    //     console.log("tooltip = ", context.tooltip, tooltipEl.parentNode);
    //     tooltipEl.parentNode.style.position = 'relative';
    //     tooltipEl.style.position = 'absolute';
    //     tooltipEl.style.backgroundColor = '#fff';
    //     // Hide if no tooltip
    //     if (tooltip.opacity === 0) {
    //         tooltipEl.style.opacity = 0;
    //         return;
    //     }

    //     // Set Text
    //     if (tooltip.body) {
    //         const titleLines = tooltip.title || [];
    //         const bodyLines = tooltip.body.map(b => b.lines);

    //         const tableHead = document.createElement('thead');
    //         titleLines.forEach(title => {
    //             const tr = document.createElement('tr');
    //             tr.style.borderWidth = 0;

    //             const th = document.createElement('th');
    //             th.style.borderWidth = 0;
    //             const text = document.createTextNode(title);

    //             th.appendChild(text);
    //             tr.appendChild(th);
    //             tableHead.appendChild(tr);
    //         });
    //         // console.log("tableHead = ",tableHead);

    //         const tableBody = document.createElement('tbody');
    //         bodyLines.forEach((body, i) => {
    //             const colors = tooltip.labelColors[i];

    //             const span = document.createElement('span');
    //             span.style.background = colors.backgroundColor;
    //             span.style.borderColor = colors.borderColor;
    //             span.style.borderWidth = '2px';
    //             span.style.marginRight = '10px';
    //             span.style.height = '10px';
    //             span.style.width = '10px';
    //             span.style.display = 'inline-block';

    //             const tr = document.createElement('tr');
    //             tr.style.backgroundColor = 'inherit';
    //             tr.style.borderWidth = 0;

    //             const td = document.createElement('td');
    //             td.style.borderWidth = 0;

    //             const text = document.createTextNode(body);

    //             // td.appendChild(span);
    //             td.appendChild(text);
    //             tr.appendChild(td);
    //             tableBody.appendChild(tr);
    //         });
    //         // console.log("tableBody = ",tableBody);

    //         const tableRoot = tooltipEl.querySelector('table');
    //         // console.log("tableRoot = ", tableRoot)
    //         // Remove old children
    //         while (tooltipEl.firstChild) {
    //             tooltipEl.firstChild.remove();
    //         }

    //         // Add new children
    //         tooltipEl.appendChild(tableHead);
    //         tooltipEl.appendChild(tableBody);
    //     }

    //     const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

    //     // Display, position, and set styles for font
    //     tooltipEl.style.opacity = 1;
    //     tooltipEl.style.display = 'absolute';
    //     tooltipEl.style.left = positionX + context.tooltip.caretX + 'px';
    //     tooltipEl.style.top = positionY + context.tooltip.caretY + 'px';
    //     tooltipEl.style.font = tooltip.options.bodyFont.string;
    //     tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
    //     console.log("position = ", tooltipEl.style.left, tooltipEl.style.top, chart)
    // };

    const findLabel = (labels, evt) => {
        // console.log("labels = ", labels, evt)
        let found = false;
        let res = null;
        try {
            // labels.forEach(l => {
            //     l.labels.forEach((label, index) => {
            //         console.log("label = ",evt,label)

            //         if (evt.x > label.x && evt.y > label.y ) {
            //             res = {
            //                 label: label.label,
            //                 index
            //             };
            //             console.log("res = ",res)
            //             setFoundMode(true);
            //         }
            //     });
            // });

            labels[0].labels.forEach((label, index) => {

                // if (Math.round(evt.x) >= Math.round(label.x) && Math.round(evt.y) >= Math.round(label.y)) {
                if (Math.round(evt.x) >= Math.round(label.x) && Math.round(evt.x) <= Math.round(label.x2) && Math.round(evt.y) >= Math.round(label.y) && Math.round(evt.y) <= Math.round(label.y2)) {
                    res = {
                        label: label.label,
                        index
                    };
                    found = true;
                    // console.log("label = ", evt, label)
                    // console.log("res = ", res, found)
                    // setFoundMode(true);
                }
            });

        } catch (e) { }

        return [found, res];
    };
    const getLabelHitboxes = (scales) => {
        // console.log("scales = ", scales)
        try {
            return Object.values(scales).map((s) => ({
                scaleId: s.id,
                labels: s._labelItems.map((e, i) => ({
                    x: e.options.translation[0] - s._labelSizes.widths[i],
                    x2: e.options.translation[0] + s._labelSizes.widths[i] / 2,
                    y: e.options.translation[1] - s._labelSizes.heights[i] / 2,
                    y2: e.options.translation[1] + s._labelSizes.heights[i] / 2,
                    label: e.label,
                    index: i
                }))
            }));
        } catch (e) { }
    };
    const changeCursorAndLabelColor = (event, chart, index, hoverMode, labelInfo) => {
        // your hover color here
        // const hoverColor = '#ff0000';
        // console.log("inside")
        const hoverColor = 'red';
        const hoverColors = [];
        const defaultLabelColor = 'pink'
        // console.log("changeCursorAndLabelColor = ", event, index, hoverMode, labelInfo)
        for (let i = 0; i < MixedRef.current.data.datasets[0].data.length; i++) {

            // console.log("i - ", i)
            if (hoverMode) {
                // change cursor
                event.native.target.style.cursor = 'pointer';
                if (index === i) {
                    hoverColors.push(hoverColor);
                } else {
                    hoverColors.push(defaultLabelColor);
                }
            } else {
                // change cursor
                event.native.target.style.cursor = 'default';
                hoverColors.push(defaultLabelColor);
            }
            // console.log('hoverColors = ', hoverColors, MixedRef.current, MixedRef.current.config.options.scales.y.ticks.color)
        }
        if (labelInfo?.label) {
            deleteDataAttribute('data-label-hover');
            const div = document.createElement('div');
            div.style.background = "red";
            div.style.borderColor = 'blue';
            div.style.borderWidth = '2px';
            div.style.marginRight = '10px';
            div.style.height = '10px';
            div.style.width = '10px';
            div.style.display = 'inline-block';
            div.style.position = 'absolute';
            div.style.top = `${event.y}px`
            div.style.left = `${event.x}px`
            console.log("e = ", event.y, event.x);
            div.setAttribute('data-label-hover', labelInfo?.label)
            div.innerHTML = `${labelInfo?.label}`;
            document.getElementById('mixed-graph').appendChild(div);
        }
        // change label to your hover color
        MixedRef.current.config.options.scales.x.ticks.color = 'red';

        // update chart when hover is triggered
        MixedRef.current.update();
    }
    const deleteDataAttribute = (dataAttribute) => {
        const dataSet = document.querySelectorAll(`[${dataAttribute}]`);
        // console.log("dataset = ", dataSet);
        if (dataSet.length > 0) {
            for (let i = 0; i < dataSet.length; i++) {
                dataSet[i].remove()
            }
        }
    }


    // <block:plugin:0>
    const getOrCreateLegendList = (chart, id) => {
        const legendContainer = document.getElementById("customLegend");
        if (legendContainer) {
            let listContainer = legendContainer?.querySelector('ul');
            if (!listContainer) {
                listContainer = document.createElement('ul');
                listContainer.style.display = 'flex';
                listContainer.style.flexDirection = 'row';
                listContainer.style.margin = 0;
                listContainer.style.padding = 0;
                legendContainer.appendChild(listContainer);
            }
            return listContainer;
        }
    };
    const loadLegend = () => {
        // console.log("legends = ", MixedRef?.current?.data?.datasets?.every((d, i) => d?.data?.length == 0))
        if (!MixedRef?.current?.data?.datasets?.every((d, i) => d?.data?.length == 0)) {
            const ul = getOrCreateLegendList(MixedRef.current, "customLegend");
            if (!ul) return
            // Remove old legend items
            while (ul?.firstChild) {
                ul.firstChild.remove();
            }
            // Reuse the built-in legendItems generator
            const items = MixedRef?.current?.options?.plugins?.legend?.labels.generateLabels(MixedRef.current);
            items.forEach(item => {
                const li = document.createElement('li');
                li.style.alignItems = 'center';
                li.style.cursor = 'pointer';
                li.style.display = 'flex';
                li.style.flexDirection = 'row';
                li.style.marginLeft = '10px';

                li.onclick = () => {
                    const { type } = MixedRef.current.config;
                    if (type === 'pie' || type === 'doughnut') {
                        // Pie and doughnut charts only have a single dataset and visibility is per item
                        MixedRef.current.toggleDataVisibility(item.index);
                    } else {
                        MixedRef.current.setDatasetVisibility(item.datasetIndex, !MixedRef.current.isDatasetVisible(item.datasetIndex));
                    }
                    // MixedRef.current.legend.legendItems[item.datasetIndex].textDecoration = 'line-through'
                    // console.log("inside onclick = ", item, MixedRef.current.isDatasetVisible(item.datasetIndex), MixedRef.current)
                    MixedRef.current.update();
                    setAreaGraphRefresh(prev => prev + 1)
                };

                // Color box
                const boxSpan = document.createElement('span');
                boxSpan.style.background = item.strokeStyle;
                boxSpan.style.borderColor = item.strokeStyle;
                boxSpan.style.borderWidth = item.lineWidth + 'px';
                boxSpan.style.display = 'inline-block';
                boxSpan.style.height = '20px';
                boxSpan.style.marginRight = '10px';
                boxSpan.style.width = '20px';
                // Text
                const textContainer = document.createElement('p');
                textContainer.style.color = item.fontColor;
                textContainer.style.margin = 0;
                textContainer.style.padding = 0;
                textContainer.style.textDecoration = item.hidden ? 'line-through' : 'none';

                const text = document.createTextNode(item.text);
                textContainer.appendChild(text);

                li.appendChild(boxSpan);
                li.appendChild(textContainer);
                ul.appendChild(li);
            });
        }
    }


    const options_mixed_graph_labels = {
        responsive: false,
        maintainAspectRatio: false,
        barPercentage: 1,
        redraw: true,
        categoryPercentage: areaCapacity?.labels?.length <= 5 ? areaCapacity?.labels?.length / 20 : 0.9,
        scales: {
            x: {
                title: {
                    display: false,
                    // align:'start',
                    padding: {
                        top: 40,
                    },
                    text: 'Areas',
                    font: {
                        family: 'Open Sans',
                        size: 12,
                        weight: 600,
                        color: graphColor.title
                    }
                },
                ticks: {
                    display: false,
                    maxRotation: 90,
                    minRotation: 90
                },
                display: false,
                border: {
                    color: graphColor.border
                },
                grid: {
                    display: false
                },

            },
            y: {
                title: {
                    display: true,
                    text: 'Capacity',
                    font: {
                        family: 'Open Sans',
                        size: 12,
                        weight: 600,
                        color: graphColor.title
                    }
                },
                grid: {
                    display: false,
                    color: graphColor.gridline,
                    tickColor: graphColor.gridline
                },
                ticks: {
                    display: true,
                    beginAtZero: false,
                    callback: function (value) { if (value % 1 === 0) { return value; } }
                },
                border: {
                    color: graphColor.border,
                    dash: [2, 2]
                },
                tickBorder: {
                    dash: [0, 0]
                },
                display: true,
            },
        },
        onHover: (event, chart) => {
            // console.log("evt = ", event)
            const evt = event;
            if (evt.type == 'mousemove') {
                // console.log("event = ",evt)
                const [found, labelInfo] = findLabel(getLabelHitboxes(MixedRef.current.scales), evt);
                // console.log("found = ", found, labelInfo)
                // console.log("data = ", evt, chart, labelInfo)
                if (found && MixedRef.current.data.labels.includes(labelInfo.label)) {
                    changeCursorAndLabelColor(evt, MixedRef.current, labelInfo.index, true, labelInfo);
                    // foundMode = true;
                    setFoundMode(true)
                } else {
                    if (foundMode) { changeCursorAndLabelColor(evt, MixedRef.current, null, false, labelInfo); }
                    // foundMode = false;
                    deleteDataAttribute('data-label-hover')
                    setFoundMode(false)
                }
            }
            else if (evt.type == "mouseout") {
                if (foundMode) changeCursorAndLabelColor(event, chart, null, false, {});
                // foundMode = false;
                setFoundMode(false);
                deleteDataAttribute('data-label-hover');
            }
        },
        plugins: {
            id: 'customHover',
            afterEvent: (event, chart) => {
                // console.log("evt = ", MixedRef.current.scales)
                const evt = event;
                // console.log("yess")
                if (evt.type !== 'mousemove') {
                    return;
                }
                const [found, labelInfo] = findLabel(getLabelHitboxes(MixedRef.current.scales), evt);
                // console.log("found = ", found, labelInfo)
                console.log("data = ", evt, chart, labelInfo)
                if (found && MixedRef.current.data.labels.includes(labelInfo.label)) {
                    changeCursorAndLabelColor(evt, MixedRef.current, labelInfo.index, true, labelInfo);
                    // foundMode = true;
                    setFoundMode(true)
                } else {
                    if (foundMode) { changeCursorAndLabelColor(evt, MixedRef.current, null, false, labelInfo); }
                    // foundMode = false;
                    setFoundMode(false)
                }
                // console.log('yes', MixedRef.current)
            },
            // legend: {
            //     display: false,
            //     labels: {
            //         usePointStyle: true,
            //         pointStyle: 'rect',
            //         boxWidth: 7,
            //         boxHeight: 7
            //     },
            //     position: 'top',
            //     align: 'center',
            // },
            legend: {
                display: false,
            },
            customLegend: {
                // ID of the container to put the legend in
                containerID: 'legend-container',
            },
            title: {
                display: false,
            },

            tooltip: {
                callbacks: {
                    // beforeTitle: function (context) {
                    //     return 'before title';
                    // },
                    title: function (context) {
                        // console.log("context = ", context)
                        if (context[0].datasetIndex == 0) {
                            const percentage = (areaCapacity.datasets[2].data[context[0]?.dataIndex] * 100) / areaCapacity.datasets[0].data[context[0]?.dataIndex]
                            console.log("context = ", context, areaCapacity, areaCapacity.datasets[1].data[context[0]?.dataIndex], areaCapacity.datasets[2].data[context[0]?.dataIndex], percentage);
                            return `${percentage}% Free Space`
                        }
                        else {
                            // console.log('title data = ',areaCapacityHeading[context[0].dataIndex])
                            return `${areaCapacityHeading[context[0]?.dataIndex]}`
                        }
                    },
                    label: function (context) {
                        if (context.datasetIndex == 0) {
                            // console.log("context = ", context, areaCapacity, areaCapacity.datasets[1].data[context?.dataIndex], areaCapacity.datasets[2].data[context?.dataIndex]);
                            return `${areaCapacity.datasets[2].data[context?.dataIndex]} Available Space`
                        }
                    },
                    // afterTitle: function(context){
                    //     return 'after title';
                    // },
                    // body: function(context){
                    //     return 'body';
                    // },
                },
                // enabled: false,
                // position: 'nearest',
                // external: externalTooltipHandler,
                displayColors: false,
                backgroundColor: '#fff',
                bodyColor: '#000',
                borderColor: '#000',
                borderWidth: 1,
                padding: 10,
                titleColor: '#000',
                titleFont: 'bold',
                titleFontSize: 30,
                yAlign: 'bottom',
                borderColor: '#396aff',
                fontFamily: 'Open Sans',
                // fontStyle: normal,
                fontWeight: 600,
                fontSize: '12px',
                boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.12)',
            },
        },
    }
    useEffect(() => {
        overspeedCount();
        areawiseCapacity();
        getTripDaily();
        getTripWeekly();
        getParkedVIN();
    }, [currentFilter])
    const getPlantFilterValue = async () => {
        const response = await listPlantsApi(user.plants[0]);
        // console.log("\n\nresponse = ", response.data.data.plant_data, response.data.data.plant_data.length,)        
        var a = [];
        response.data.data.plant_data.map(d => {
            if (user.plants.includes(d.plant_ids)) {
                a.push({ label: d?.plant_name, value: d?.plant_id })
            }
        })
        if (a.length === response.data.data.plant_data.length && a.every(data => response.data.data.plant_data.some(d => d.plant_id === data.value))
        ) {
            a.unshift({ label: "India", value: "all" })
        }
        // console.log("outside", a)
        setPlantFilter(a)
    }
    useEffect(() => {
        getPlantFilterValue();
        // overspeedCount();
        // areawiseCapacity();
        // getTripDaily();
        // getTripWeekly();
        // getParkedVIN();
        setPageLeaveTime(new Date())
    }, [])
    useEffect(() => {
        // console.log("overspeeding = ", overspeeding)
        setOverspeedingLabel({
            type: 'bar',
            data: overspeeding,
        })
    }, [overspeeding])
    useEffect(() => {
        return () => {
            if (new Date() - pageLeaveTime) {
                const a = path_Operation?.filter((d, i) => {
                    return d?.name == location?.pathname
                })
                postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : location?.pathname, pageLeaveTime, a[0]?.operation ? a[0]?.operation : 'view', (new Date() - pageLeaveTime))
            }
        }
    }, [pageLeaveTime])
    useEffect(() => {
        loadLegend()
    }, [document.getElementById("customLegend"), areaGraphRefresh])

    useEffect(() => {
        const responsive = areaCapacity?.labels?.length < 10 ? true : false
        // console.log("Res = ", responsive)
        setOptions_mixed_graph({
            // responsive: false,
            responsive: responsive,
            maintainAspectRatio: false,
            barPercentage: 1,
            categoryPercentage: areaCapacity?.labels?.length <= 10 ? areaCapacity?.labels?.length / 20 : 0.9,
            borderRadius: 3,
            scales: {
                x: {
                    beforeUpdate(axis) {
                        const labels = axis.chart.data.labels;
                        for (let i = 0; i < labels.length; i++) {
                            const lbl = labels[i];
                            if (typeof lbl === 'string') {
                                labels[i] = lbl.substring(0, 3) + "...";
                            }
                        }
                    },
                    title: {
                        display: true,
                        text: 'Areas',
                        font: {
                            family: 'Open Sans',
                            size: 12,
                            weight: 600,
                            color: graphColor.title
                        }
                    },
                    ticks: {
                        maxRotation: 90,
                        minRotation: 90
                    },
                    display: true,
                    border: {
                        color: graphColor.border
                    },
                    grid: {
                        display: false
                    },

                },
                y: {
                    title: {
                        display: true,
                        text: 'Capacity',
                        font: {
                            family: 'Open Sans',
                            size: 12,
                            weight: 600,
                            color: graphColor.title
                        }
                    },
                    grid: {
                        color: graphColor.gridline,
                        tickColor: graphColor.tick
                    },
                    ticks: {
                        display: true,
                        beginAtZero: false,
                        callback: function (value) { if (value % 1 === 0) { return value; } }
                    },
                    border: {
                        display: true,
                        color: graphColor.border,
                        dash: [2, 2]
                    },
                    tickBorder: {
                        dash: [0, 0]
                    },
                    display: true,
                },
            },
            // onHover: (event, chart) => {
            //     // console.log("evt = ", event)
            //     const evt = event;
            //     if (evt.type == 'mousemove') {
            //         // console.log("event = ",evt)
            //         const [found, labelInfo] = findLabel(getLabelHitboxes(MixedRef.current.scales), evt);
            //         // console.log("found = ", found, labelInfo)
            //         // console.log("data = ", evt, chart, labelInfo)
            //         if (found && MixedRef.current.data.labels.includes(labelInfo.label)) {
            //             changeCursorAndLabelColor(evt, MixedRef.current, labelInfo.index, true, labelInfo);
            //             // foundMode = true;
            //             setFoundMode(true)
            //         } else {
            //             if (foundMode) { changeCursorAndLabelColor(evt, MixedRef.current, null, false, labelInfo); }
            //             // foundMode = false;
            //             deleteDataAttribute('data-label-hover')
            //             setFoundMode(false)
            //         }
            //     }
            //     else if (evt.type == "mouseout") {
            //         if (foundMode) changeCursorAndLabelColor(event, chart, null, false, {});
            //         // foundMode = false;
            //         setFoundMode(false);
            //         deleteDataAttribute('data-label-hover');
            //     }
            // },
            plugins: {
                id: 'customHover',
                afterEvent: (event, chart) => {
                    // console.log("evt = ", MixedRef.current.scales)
                    const evt = event;
                    // console.log("yess")
                    if (evt.type !== 'mousemove') {
                        return;
                    }
                    const [found, labelInfo] = findLabel(getLabelHitboxes(MixedRef.current.scales), evt);
                    // console.log("found = ", found, labelInfo)
                    // console.log("data = ", evt, chart, labelInfo)
                    if (found && MixedRef.current.data.labels.includes(labelInfo.label)) {
                        changeCursorAndLabelColor(evt, MixedRef.current, labelInfo.index, true, labelInfo);
                        // foundMode = true;
                        setFoundMode(true)
                    } else {
                        if (foundMode) { changeCursorAndLabelColor(evt, MixedRef.current, null, false, labelInfo); }
                        // foundMode = false;
                        setFoundMode(false)
                    }
                },
                // legend: {
                //     display: true,
                //     labels: {
                //         usePointStyle: true,
                //         pointStyle: 'rect',
                //         boxWidth: 7,
                //         boxHeight: 7
                //     },
                //     position: 'top',
                //     align: 'center',
                // },
                legend: {
                    display: false,
                },
                title: {
                    display: false,
                },
                tooltip: {
                    callbacks: {
                        // beforeTitle: function (context) {
                        //     return 'before title';
                        // },
                        title: function (context) {
                            // console.log("context = ", context)
                            if (context[0].datasetIndex == 0) {
                                const percentage = Math.round((areaCapacity.datasets[2].data[context[0]?.dataIndex] * 100) / areaCapacity.datasets[0].data[context[0]?.dataIndex])
                                // console.log("context = ", context, areaCapacity, areaCapacity.datasets[1].data[context[0]?.dataIndex], areaCapacity.datasets[2].data[context[0]?.dataIndex], percentage);
                                return `${isNaN(percentage) ? "0" : percentage}% Free Space`
                            }
                            else {
                                // console.log('title data = ',areaCapacityHeading[context[0].dataIndex])
                                return `${areaCapacityHeading[context[0]?.dataIndex]}`
                            }
                        },
                        label: function (context) {
                            if (context.datasetIndex == 0) {
                                // console.log("context = ", context, areaCapacity, areaCapacity.datasets[1].data[context?.dataIndex], areaCapacity.datasets[2].data[context?.dataIndex]);
                                return `${areaCapacity.datasets[2].data[context?.dataIndex]} Available Space`
                            }
                        },
                        // afterTitle: function(context){
                        //     return 'after title';
                        // },
                        // body: function(context){
                        //     return 'body';
                        // },
                    },
                    // enabled: false,
                    // position: 'nearest',
                    // external: externalTooltipHandler,
                    displayColors: false,
                    backgroundColor: '#fff',
                    bodyColor: '#000',
                    borderColor: '#000',
                    borderWidth: 1,
                    padding: 10,
                    titleColor: '#000',
                    titleFont: 'bold',
                    titleFontSize: 30,
                    yAlign: 'bottom',
                    borderColor: '#396aff',
                    fontFamily: 'Open Sans',
                    // fontStyle: normal,
                    fontWeight: 600,
                    fontSize: '12px',
                    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.12)',
                },
            },
        })
        MixedRef?.current?.registry?.plugins?.register({
            id: "NoData_MixedRef",
            afterDraw: function (chart) {
                // console.log('After draw: ', chart);
                // console.log('Title: ', chart?.options?.title?.text);
                if (chart.data.datasets[0].data.length === 0) {
                    // No data is present
                    var ctx = chart.ctx;
                    var width = chart.width;
                    var height = chart.height;
                    chart.clear();
                    ctx.save();
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    // ctx.font = "24px 600 'Open Sans'";
                    ctx.font = "24px 'Open Sans'";
                    ctx.fillText('No data to display for selected plant', width / 2, height / 2);
                    // console.log("ctx = ",ctx);
                    ctx.save();
                    ctx.restore();
                }
            }
        })
        MixedRef?.current?.update()
    }, [areaCapacity])
    useEffect(() => {
        WeeklyTripRef?.current?.registry?.plugins?.register({
            id: "NoData_WeeklyTripRef",
            afterDraw: function (chart) {
                // console.log('After draw: ', chart.data.datasets[0].data);
                // console.log('Title: ', chart?.options?.title?.text);
                if (chart.data.datasets[0].data.every(d => d == 0)) {
                    // console.log("inside")
                    // No data is present
                    var ctx = chart.ctx;
                    var width = chart.width;
                    var height = chart.height;
                    chart.clear();
                    ctx.save();
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.font = "18px 'Open Sans'";
                    ctx.fillText('No data to display for selected plant', width / 2, height / 2);
                    ctx.restore();
                }
            }
        })
        WeeklyTripRef?.current?.update()
    }, [tripWeekly])
    useEffect(() => {
        // console.log("tripdaily called", DailyTripRef?.current?.registry.plugins)
        DailyTripRef?.current?.registry?.plugins?.register({
            id: "NoData_DailyTripRef",
            afterDraw: function (chart) {
                // console.log('After draw inside tripdaily: ', chart.data.datasets[0].data);
                // console.log('Title: ', chart?.options?.title?.text);
                if (chart.data.datasets[0].data.every(d => d == 0)) {
                    // console.log("inside")
                    // No data is present
                    var ctx = chart.ctx;
                    var width = chart.width;
                    var height = chart.height;
                    chart.clear();
                    ctx.save();
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.font = "18px 'Open Sans'";
                    ctx.fillText('No data to display for selected plant', width / 2, height / 2);
                    ctx.restore();
                }
            }
        })
        DailyTripRef?.current?.update()
    }, [tripDaily])
    useEffect(() => {
        // console.log("tripdaily called", DailyTripRef?.current?.registry.plugins)
        ParkedVehicleRef?.current?.registry?.plugins?.register({
            id: "NoData_ParkedVehicleRef",
            afterDraw: function (chart) {
                                // console.log('After draw inside tripdaily: ', chart.data.datasets[0].data);
                // console.log('Title: ', chart?.options?.title?.text);
                if (chart.data.datasets.every(dataset => dataset.data.every(d => d === 0))) {
                    console.log("inside");
                    // No data is present
                    var ctx = chart.ctx;
                    var width = chart.width;
                    var height = chart.height;
                    chart.clear();
                    ctx.save();
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.font = "18px 'Open Sans'";
                    ctx.fillText('No data to display for selected plant', width / 2, height / 2);
                    ctx.restore();
                }
            }
        })
        ParkedVehicleRef?.current?.update()
    }, [parked])
    useEffect(() => {
        // console.log("tripdaily called", DailyTripRef?.current?.registry.plugins)
        OverspeedingRef?.current?.registry?.plugins?.register({
            id: "NoData_OverspeedingRef",
            afterDraw: function (chart) {
                // console.log('After draw inside tripdaily: ', chart.data.datasets[0].data);
                // console.log('Title: ', chart?.options?.title?.text);
                if (chart.data.datasets.every(dataset => dataset.data.every(d => d === 0))) {
                    // console.log("inside")
                    // No data is present
                    var ctx = chart.ctx;
                    var width = chart.width;
                    var height = chart.height;
                    chart.clear();
                    ctx.save();
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.font = "18px 'Open Sans'";
                    ctx.fillText('No data to display for selected plant', width / 2, height / 2);
                    ctx.restore();
                }
            }
        })
        OverspeedingRef?.current?.update()
    }, [overspeeding])

    const navigate = useNavigate();
    const browserBack = () => {
        navigate("/");
    }
    const handleFilterValue = (value) => {
        // console.log("value = ", value, countRef.current)
        setcurrentFilter(value);
    }
    return (
        <>
            {
                loader ?
                    <>
                        <div className='breadcrumb'>
                            <BackButton action={"Overall Summary"} handleClick={browserBack} isbulkDownloaded={isbulkDownloaded} bulkSearchButton={bulkSearchButton} data={overspeeding} />
                        </div>
                        <div className="headerwithcount">
                            <div className='countdiv'>
                                <CustomTab
                                    isSelected={false}
                                    title={"Overall Summary"}
                                    withOutCount={true}
                                // count={}
                                />
                            </div>

                            <div className="blankdiv">
                                <span className='blankdiv-title mediumFont'>
                                    {""}
                                </span>
                                {/* <div style={{ marginRight: '10px' }}>
                                    <Select title={"overallSummaryDropdown"} options={plantFilter} onChange={handleFilterValue} selectClassName={"dispatch-history-header-dropdown"} />
                                </div> */}

                            </div>
                        </div>
                        <div className="blankdiv" >
                            {/* <input
                                type="file"
                                accept=".csv,.xlsx,.xls"
                                id='input_file'
                                onChange={handleFileUpload}
                                hidden
                            /> */}
                        </div>
                        <div className={styles.dashboardAnalyticsContainer}>
                            <div className={clsx(styles.mixedGraphContainer, styles.graphContainer)} id="mixed-graph">
                                <div style={{ display: "flex" }}>
                                    <div className={styles.graphTitles}>
                                        Areawise Capacity Utilization
                                    </div>
                                    {/* <div className={styles.areaWiseCapacityGraph} style={{
                                        overflowX: "hidden",
                                        overflowY: "hidden",
                                        top: 55,
                                        position: "absolute"
                                    }}
                                    >
                                        <Bar
                                            // ref={MixedRef}
                                            data={areaCapacityAxis}
                                            width={1500}
                                            height={275}
                                            options={options_mixed_graph_labels}
                                        />
                                    </div> */}
                                    <div id="customLegend" className={styles.customLegendArea}></div>
                                </div>
                                <div className={styles.areaWiseCapacityGraph} id="mixed-graph-parent" style={{ position: "relative", width: "100%" }} >
                                    <Bar
                                        ref={MixedRef}
                                        data={areaCapacity}
                                        width={graphWidth}
                                        height={350}
                                        options={options_mixed_graph}
                                        style={{ width: areaCapacity?.labels?.length < 10 ? Number(document.getElementById("mixed-graph-parent")?.offsetWidth) : graphWidth, height: '350px' }}
                                    />
                                </div>
                            </div>
                            {/* Overspeeding Graph */}
                            <div className={clsx(styles.graphContainer, styles.overspeedCountGraph)}>
                                <div className={styles.graphTitles}>
                                    Overspeeding Count
                                </div>
                                <Bar
                                    ref={OverspeedingRef}
                                    data={overspeeding}
                                    width={'40vw'}
                                    height={'23vh'}
                                    options={options_overspeeding}
                                    style={{ flexGrow: 3 }}
                                />
                            </div>
                            {/* Parked Vehicle */}
                            <div className={clsx(styles.graphContainer, styles.parkedVehicleGraph)}>
                                <div className={styles.graphTitles}>
                                    Parked Vehicle
                                </div>
                                <Line
                                    ref={ParkedVehicleRef}
                                    data={parked}
                                    width={'40vw'}
                                    height={'19vh'}
                                    options={options_line_graph}
                                    style={{ flexGrow: 7 }}
                                />
                            </div>
                            {/* Number of Trips (Daily) */}
                            <div className={clsx(styles.graphContainer, styles.tripsDailyGraph)}>
                                <div className={styles.graphTitles}>
                                    Number of Trips (Daily)
                                </div>
                                <Bar
                                    ref={DailyTripRef}
                                    data={tripDaily}
                                    width={'40vw'}
                                    height={'23vh'}
                                    options={options_trips_daily}
                                    style={{ flexGrow: 3 }}
                                />
                            </div>
                            {/* Number of Trips (Weekly) */}
                            <div className={clsx(styles.graphContainer, styles.tripWeeklyGraph)} >
                                <div className={styles.graphTitles}>
                                    Number of Trips (Weekly)
                                </div>
                                <Bar
                                    ref={WeeklyTripRef}
                                    data={tripWeekly}
                                    width={'45vw'}
                                    height={'21vh'}
                                    options={options_trip_weekly}
                                    style={{ flexGrow: 7 }}
                                />
                            </div>
                        </div>
                    </>
                    :
                    <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Loader />
                    </div>
            }
        </>
    )
}